var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_120_38",
    "data-name": "Component 120 \\u2013 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Number_style_",
    "data-name": "Number (style)",
    width: 28,
    height: 28,
    rx: 6,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_trash_light",
    "data-name": "UI icon/trash/light",
    transform: "translate(4 4)",
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38_Copy_Stroke_",
    "data-name": "Path 38 Copy (Stroke)",
    d: "M1,0A1,1,0,0,1,2,1V6A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0Z",
    transform: "translate(7 8)",
    fill: "#ed2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38_Copy_Stroke_2",
    "data-name": "Path 38 Copy (Stroke)",
    d: "M1,0A1,1,0,0,1,2,1V6A1,1,0,0,1,0,6V1A1,1,0,0,1,1,0Z",
    transform: "translate(11 8)",
    fill: "#ed2024"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M15,20H5a3,3,0,0,1-3-3V5H1A1,1,0,0,1,1,3H5A3,3,0,0,1,8,0h4a3,3,0,0,1,3,3h4a1,1,0,0,1,0,2H18V17A3,3,0,0,1,15,20ZM4,5V17a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V5H4ZM8,2A1,1,0,0,0,7,3h6a1,1,0,0,0-1-1Z",
    fill: "#ed2024"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAvatar);
export default __webpack_public_path__ + "static/media/deleteAvatar.0501a88440300c0e7f6544eeff68ecc2.svg";
export { ForwardRef as ReactComponent };